export default __webpack_public_path__ + "static/media/profileImg12.24903f1e.png";